import React from 'react';
import { useLocation, useOutlet, Navigate } from 'react-router-dom';
import Layout from './Layout';
import { useSelectedSchool } from '../contexts/SelectedSchoolContext';

/**
 * When parent has multiple schools and none selected, redirect to /select-school.
 * When on /select-school, render outlet only. Otherwise render Layout with outlet.
 */
export default function ParentAppGate() {
  const location = useLocation();
  const outlet = useOutlet();
  const { hasMultipleSchools, selectedSchoolId } = useSelectedSchool();

  if (location.pathname === '/select-school') {
    return <>{outlet}</>;
  }
  if (hasMultipleSchools && !selectedSchoolId) {
    return <Navigate to="/select-school" replace />;
  }
  return <Layout />;
}
